import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { AppUserResponse } from '@/types/apps/app-user.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface AppUserGraphQLServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

type AppUserListResponse = GqlListResponse<AppUserResponse>;

export class AppUserGraphQLService
    extends BaseService
    implements AppUserGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'appUser';
    }

    public getFields(): Record<string, any> {
        return {
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            email: true,
            emailConfirmed: true,
            firstname: true,
            fullname: true,
            id: true,
            isCustomer: true,
            isDeleted: true,
            lastname: true,
            lockoutEnabled: true,
            lockoutEnd: true,
            modifiedBy: true,
            modifiedDate: true,
            normalizedEmail: true,
            normalizedUserName: true,
            phoneNumber: true,
            phoneNumberConfirmed: true,
            position: true,
            securityStamp: true,
            twoFactorEnabled: true,
            userName: true,
            userRoles: {
                roleId: true,
                userId: true,
            },
        };
    }

    public async index(query: string): Promise<AppUserListResponse> {
        return this.fetchGqlList(query, this.getEntityName()).then(res => {
            return {
                ...res,
                items: res.items.map((item: AppUserResponse) => ({
                    ...item,
                    customName: `${item.email} - ${item.fullname}`,
                })),
            };
        });
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        return {};
    }

    public getFieldSearch(): string {
        return 'fullname';
    }
}
